interface DomainColors {
  text: string;
  background: string;
}

/** Domains share a colour in three groups: es/ebs/rc, is/esl, and co. */
const NUDE: DomainColors = {
  text: 'text-ds-nude-12',
  background: 'bg-ds-nude-5'
};

const VIOLET: DomainColors = {
  text: 'text-ds-violet-11',
  background: 'bg-ds-violet-3'
};

const AQUA: DomainColors = {
  text: 'text-ds-aqua-11',
  background: 'bg-ds-aqua-2'
};

const domainColors: { [abbreviation: string]: DomainColors } = {
  es: NUDE,
  ebs: NUDE,
  rc: NUDE,
  is: VIOLET,
  esl: VIOLET,
  co: AQUA
};

/** Falls back to no colour at all, for an age level not listed above. */
export function getDomainColors(abbreviation: string): DomainColors {
  return domainColors[abbreviation] ?? { text: '', background: '' };
}
